import { render, staticRenderFns } from "./landing-page-form-publish-widget.vue?vue&type=template&id=bcec080e&"
import script from "./landing-page-form-publish-widget.vue?vue&type=script&lang=js&"
export * from "./landing-page-form-publish-widget.vue?vue&type=script&lang=js&"
import style0 from "./landing-page-form-publish-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports